// Setup Vue
import { createApp } from 'vue'
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import modalDynamic from './components/modal-dynamic.vue';
import oasisModal from './components/oasis-modal.vue';
import Roster from './components/Roster.vue';
import Planner from './components/Planner.vue';
require('./classes/PrototypeExt.js');

var app = createApp({

    components: {
        'modal-dynamic': modalDynamic,
        'oasis-modal': oasisModal,
        Roster,
        Planner,
    },
    data() {
        return {
            waiting: false, // whole-page spinner
            loading: false, // spinner
            adminAccess: false,
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            oasisApi: new Axios('/restv2'),
            timecardFA: timecardFA,
            isFinalApproverByTier: isFinalApproverByTier,
            entityId: undefined,
        }
    },

    computed: {
    },

    methods: {
        pushArray(data, array, sort) {
            array.pushUnique(data, sort);
            return data;
        },

        // Generic test function
        log(value) {
            console.log('Logging:');
            console.log(value);
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) {
                this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () { }; }

            if (options.buttonYesLabel) {
                this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) {
                this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () { }; }

            if (options.buttonNoLabel) {
                this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) {
                this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () { }; }

            if (options.button3Label) {
                this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },

        createLink(value) {
            return value;
        },

        openWindow(link = '', target = '') {
            // console.log(link)
            let child = window.open(link, target);
            child.onunload = () => {
                this.loadDashboardData();
            };
        },
    },

    async mounted() {
        setTimeout(() => { $('[data-toggle="tooltip"]').tooltip() }, 500);
        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };
        this.adminAccess = typeof adminAccess !== 'undefined' ? (adminAccess ? true : false) : false;
        this.entityId = entityId;
    }
}).mount("#dashboard");
